// @flow

const VITALLY_API_KEY = process.env.REACT_APP_VITALLY_API_KEY;

// https://docs.vitally.io/en/articles/9836612-installing-configuring-nps
const VitallyNPSOptions = {
  productName: 'Boost AI Search & Discovery',
  autoLoadSegment: false, // Set to true if using Segment
  delay: 1000 // Delay in milliseconds before showing the survey
};

// eslint-disable-next-line
export const initVitally = tenantApp => {
  // Only init at first load when data is ready
  if (VITALLY_API_KEY && tenantApp && !window.Vitally) {
    // Add Vitally script
    const vitallyScript = document.createElement('script');
    vitallyScript.src = 'https://cdn.vitally.io/vitally.js/v1/vitally.js';
    vitallyScript.async = true;
    document.body.appendChild(vitallyScript);
    const id = `BC_${tenantApp.externalInfo?.id}`;
    const email = tenantApp.externalInfo?.email;
    const createdAt = new Date(tenantApp.recentInstalledAt * 1000 || Date.now()).toISOString();

    vitallyScript.onload = () => {
      // Initialize Vitally NPS
      window.Vitally = window.Vitally || [];
      window.Vitally.init(VITALLY_API_KEY, 'https://clearer.api.vitally.io/analytics/v1');
      window.Vitally.account({ accountId: id, traits: { createdAt } });
      window.Vitally.user({ userId: id, accountId: id, traits: { email, createdAt } });

      console.log('initVitally()', { accountId: id, tenantId: tenantApp.tenantId });

      // show survey based on rules configured in Vitally dashboard
      window.Vitally.nps('survey', VitallyNPSOptions);

      // force show to test at local
      // window.Vitally.nps('show', VitallyNPSOptions);
    };
  }
};
